import canUser from '@pkg/entities/users/access/can';

/**
 * @param {Object} me
 * @param {Object} permissions
 * @returns {Boolean}
 */
export default function edit(me, permissions) {
  return canUser(me, permissions.organisation.write);
}
